import React, {useState, useRef, useEffect} from "react"
import { Link } from "react-router-dom"
import { mainAxios } from '../../services/mainAxios'
import "react-datepicker/dist/react-datepicker.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {  faEye, faPlus } from "@fortawesome/free-solid-svg-icons"
import Loader from "../Layout/Loader"
import { useAppContext, usePersistedState } from '../../AppContext'
import {useTranslation, withTranslation} from "react-i18next";
import AlertCertificate from "../global/AlertCertificate"
import PrimeTable from "../PrimeTable/PrimeTable"
import { Column } from "primereact/column"
import ExportCsvPrime from "../global/ExportCsvPrime"
import { useHistory } from 'react-router-dom';
import { subscriptionStatus } from "../../services/data"
import { Dialog } from "primereact/dialog"
import AddCompany from "./Company/AddCompany"

const moment = require("moment")


const Companies = (props) => {
  const history=useHistory();
    const {t,i18n} = useTranslation('translations');
    const [companiesForCsv, setCompaniesForCsv] = useState([]);
    const { user: [user,], selectedCompany: [selectedCompany,] } = useAppContext()
    const [loadingGrid,setLoadingGrid]=useState(false)
    const [expandedRows,setExpandedRows]=useState([])
    const [companies, setCompanies] = useState(null)
    const defaultSortCriteria={
      field: "recordDate",
      direction: "DESC"
    }
    const defaultFilters = {
      active: null
    }
    const [filters, setFilters] = useState({
      params:{}
    });
    const [tableRows, setTableRows] = useState({
        totalRows: 0,
        rowsPerPage: 10,
        currentPage: 1,
        sortCriteria:defaultSortCriteria
      });

      const isSysAdmin=user?.role?.id===1

      React.useEffect(() => {
        getFilteredResults();
      },[]);

      const getFilteredResults = async({
        updatedFilters,
        rowsPerPage = 10,
        currentPage = 1,
        exportCsv = false,
        sortCriteria=[ defaultSortCriteria ],
      } = {}) => {
        let requestBody = {
          object: "GetSimpleCompany",
          value: null,
          params: updatedFilters?.params,
          pagination: exportCsv ? null : {
            pageSize: rowsPerPage,
            pageNumber: currentPage,
          },
          sortCriteria,
        };
        setLoadingGrid(true);
        return await mainAxios
          .post("apiEndpoint/search", requestBody)
          .then((res) => {
            setLoadingGrid(false);
            if (res?.data?.status === true) {
              let companies = res?.data?.content.map(company => {
                const subscriptions = company?.companySubscriptionViews ?? [];
            
                const activeSubscriptions = subscriptions.filter(sub => String(sub.status) === "1");
                let selectedSub;
              
                if (activeSubscriptions.length > 0) {
                  activeSubscriptions.sort((a, b) => b.startDate - a.startDate);
                  selectedSub = activeSubscriptions[0];
                } else {
                  const sortedByEndDate = [...subscriptions].sort((a, b) => b.endDate - a.endDate);
                  selectedSub = sortedByEndDate[0];
                }
              
                return {
                  ...company,
                  beginningDate: selectedSub?.startDate ?? null,
                  expirationDate: selectedSub?.endDate ?? null
                };
              });
              
              
              if (exportCsv) {
                 setCompaniesForCsv(companies);
                return true;
              } else {
                setCompanies(companies);
                setTableRows((tableRows) => ({
                  ...tableRows,
                  totalRows: res?.data?.totalSize,
                }));
              }
            }
          })
          .catch((err) => {
            console.log({ err });
            setLoadingGrid(false);
          });
      };
      const [open, setOpen] = useState({id:null,open:false});
      const clearCompany = () => {
        setOpen({id:null,open:false})
    }

    const columns = [
        {
            header: t(['company.name']),
            field: 'name',
            default: true,
            sortable: true,
            style:{ minWidth: '150px', maxWidth:"150px" },
            filter:true,
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },
        {
            header: 'NIPT',
            field: 'nuis',
            default: true,
            sortable: true,
            style:{ minWidth: '150px', maxWidth:"150px" },
            filter:true,
            mobile: { priority: 1, group: "identity" },
        },
        {
            header: t('company.issuerInVat'),
            field: 'issuerInVat',
            default: true,
            dataType: "boolean",
            filterType: "TRISTATECHECKBOX",
            format:(company)=>company?.issuerInVat?"TRUE":"FALSE",
            sortable: true,
            style:{ minWidth: '170px', maxWidth:"170px" },
            filter:true,
            mobile: { priority: 1, group: "reference" },
        },
        {
            header:  t(['home.dateActivProfisc']),
            field: 'recordDate',
            default: true,
            // filterType: "DATE",
            sortable: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            // filter:true,
            body: company => company.recordDate ? moment(company.recordDate).format("DD/MM/YYYY HH:mm") : "",
            mobile: { priority: 1, group: "dates" },
        },
        {
            header: t(['company.type']),
            field: 'type',
            default: true,
            sortable: true,
            mobile: { priority: 1, group: "reference" },
        },
        {
          header: t(['company.beginofSubscription']),
          field: 'startDate',
          default: true,
          filterType: "DATE",
          formattedExportValue: true,
          preventExcelFormat: true,
          style:{ minWidth: '220px', maxWidth:"220px" },
          body: company => company.beginningDate ? moment(company.beginningDate).format("DD/MM/YYYY HH:mm") : "",
          filter: true,
          sortable: true,
          persisted:false,
          mobile: { priority: 1, group: "dates" },
        },
        {
            header: t(['company.endofSubscription']),
            width: "220px",
            formattedExportValue: true,
            preventExcelFormat: true,
            body: company => company.expirationDate ? moment(company.expirationDate).format("DD/MM/YYYY HH:mm") : "",
            field: 'endDate',
            default: true,
            sortable: true,
            filterType: "DATE",
            style:{ minWidth: '200px', maxWidth:"200px" },
            filter:true,
            mobile: { priority: 1, group: "dates" },
        },
          {
          header: t(['company.active']),
          field: 'isActive',
          default: true,
          dataType: "boolean",
          filter:true,
          align:"center",
          filterType:"TRISTATECHECKBOX",
          format: (company) => {
            return company.active ? 'Yes' : 'No'
         },
          body: company => company.active ? t(['company.yes']) : t(['company.no']),
          mobile: {
            priority: 1,
            isBadge: true,
            group: "status",
            mobileBody: (company) => (
              <span className={`badge ${company.active ? 'bg-success' : 'bg-danger'}`}>
                {company.active ? 'Aktive' : 'Joaktive'}
              </span>
            ),
          },
        },
        {
            field:"actions",
            default: true,
            persisted: true,
            header:  t(['home.actions']),
            mobile: { priority: "action", group: "actions" },
            body: company => (
                <>
                    <div
                        onClick={()=> history.push("/companies/" + company.id,tableRows.totalRows)}
                        className="nav-link text-primary p-0 mr-2 cursor-pointer d-flex align-items-center gap-1">
                        <FontAwesomeIcon icon={faEye} className="mr-1" />
                        {t('company.view')}
                    </div>
                </>
            )
        }
    ];

    const [selectedColumns, setSelectedColumns] = usePersistedState(
        columns.map((col) => ({ field: col.field, show: !!col.default, ...(col?.persisted ? { persisted: true } : {}) })),
        "companiesColumns1"
    );

    const expandableColumns = [
        {
            header:  t(['company.businUnitCode']),
            field: 'businUnitCode',
            style: { minWidth: "100px", maxWidth: "100px" },
        },
        {
          header: t("company.profiscStat"),
          field: 'profiscStatus',
          sortable: true,
          style:{ minWidth: '150px', maxWidth:"150px"},
          align:"center",
          dataType:"boolean",
        },
        {
            header: t(['home.dateActivProfisc']),
            field: 'recordDate',
            body: row => row?.recordDate ? moment(row.recordDate).format("DD/MM/YYYY HH:mm") : "",
            style: { minWidth: "200px", maxWidth: "200px" },
        },
        {
            header: t(['company.sellerAddress']),
            field: 'sellerAddress',
            style: { minWidth: "350px", maxWidth: "350px" },
        },
        {
            header: t(['company.default']),
            field: 'default',
            body: row => row?.default ? t(['company.yes']) : t(['company.no']),
            style: { minWidth: "150px", maxWidth: "150px" },
        }
    ];

    let data = companies ?? null

    const rowExpansionTemplate = (e)=>{
      return (
        <div className="prime-header-sticky" style={{ marginBottom:20 }}>
        <PrimeTable
          value={e?.branches ?? []}
          columns={expandableColumns}
          simpleTable={true}
          showFilters={false}
          paginator={false}
          filterDisplay={false}
          responsiveLayout="scroll"
          // scrollable={true}
          // scrollHeight="400px"
      />
  </div>)

    }

    // Export icon for headerIcons
    const exportIcon = (
      <ExportCsvPrime
        iconOnly
        tooltip="Export CSV"
        data={companiesForCsv}
        columns={columns}
        selectedColumns={selectedColumns}
        onClick={() => getFilteredResults({exportCsv:true,updatedFilters:filters})}
        excludedColumns={["actions"]}
      />
    );

    return data ? (
      <>
        <Dialog
                header={t("navbar.addCompany")}
                visible={open.open}
                onHide={() => clearCompany()}
                style={{ width: "800px",height:"100%" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                headerStyle={{paddingBottom:0}}
                className="add-copany-dialog"
            >
                {open?.open &&<AddCompany
                    onDataSuccess={()=>{
                        setOpen({id:null,open:false});
                        getFilteredResults({updatedFilters:filters, rowsPerPage:tableRows.rowsPerPage, currentPage:tableRows.currentPage})
                    }}
                    clearCompany={clearCompany}
                    id={open?.id}
                />}
            </Dialog>
        <div className="d-flex flex-wrap justify-content-between align-items-center my-2">
          <div className="d-flex align-items-center">
            <h3 className="p-0 m-0">{t("navbar.companies")}</h3>
            {isSysAdmin && (
              <button
                className="btn btn-sm btn-primary ml-3"
                onClick={() => setOpen({id:null,open:true})}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                {t("subscription.add")}
              </button>
            )}
            <AlertCertificate />
          </div>
        </div>
        <div>
          <PrimeTable
                loading={loadingGrid}
                filters={[filters, setFilters]}
                tableRows={[tableRows, setTableRows]}
                value={companies}
                columns={columns}
                defaultFilters={defaultFilters}
                onRowToggle={(e) => setExpandedRows(e.data)}
                expandedRows={expandedRows}
                rowExpansionTemplate={rowExpansionTemplate}
                responsiveLayout="scroll"
                dataKey="id"
                clearFilters={true}
                headerButtonsRight
                headerIcons={exportIcon}
                showSelectColumns
                gridKey="companiesColumns1"
                selectedColumns={[selectedColumns, setSelectedColumns]}
                showFilters={true}
                reorderableColumns={true}
                onRemoteDataChange={(remoteData) => {
                    const updatedFilters = remoteData.filters ?? filters
                    const updatedTableData = remoteData.tableRows ?? tableRows
                    let { currentPage, rowsPerPage,sortCriteria } = updatedTableData
                    sortCriteria = sortCriteria ? [sortCriteria] : null
                    getFilteredResults({updatedFilters, rowsPerPage, currentPage,sortCriteria,searchQuery:remoteData?.searchQuery})
                }}
               defaultSortCriteria={defaultSortCriteria}
            >
              <Column
                expander={() => true}
                style={{ width: "0.5em" }}
                header=""
                field="expansionCol"
                frozen={true}
              />
            </PrimeTable>
        </div>
      </>
    ) : (
      <Loader />
    );
}

export default Companies;
